import './DistrictComponents.scss'

import React from "react";
import STATES_HASH from "../Util/states";
import { isSingleDistrictState } from "../Util/DataHelper";

function DistrictHeader(props) {
  // District Number will say 'At Large' if there is only one district exists
  // in that state.
  let districtText = <div className="district-text">
      <h2>District</h2><strong className="h2">{props.selectedDistrict}</strong></div>;
  if (isSingleDistrictState(props.selectedState)) {
    districtText = <div className="district-text">
        <h2>District At large</h2></div>;
  }

  if (props.selectedState && props.selectedDistrict) {
    return (
      <div className="state-district-header">
        <h1>{STATES_HASH[props.selectedState]}</h1>
        {districtText}
        <div className="nafsa-logo">
          <img src={`/themes/custom/nafsa/images/nafsa_logo_isev.jpg`} alt="nafsa-logo"/>
        </div>
      </div>
    )
  } else {
    return (<div><strong className="header-subtitle">Benefits from International Students</strong></div>)
  }
}

function TopDistrictInstitutions(props) {
  const listInstitutions = props.institutions.map(function (institution, i) {
    return (
      <li key={institution.unitID}>
        <div className="name"><strong>{institution.name}</strong></div>
        <div className="rank"><span>{i + 1}</span></div>
        <div className="jobs"><span>{institution.dollars} <em>supporting</em> {institution.jobs} jobs</span></div>
      </li>
    );
  });

  return (
    <div className="top-district-institutions">
      <h3 className="top-district-institutions-title">Top Higher Education Institutions <span>(Dollars and Jobs)</span></h3>
      {listInstitutions.length > 0 ?
        <ul className="top-district-institutions-body">{listInstitutions}</ul> :
        <p className="zero-results">NAFSA Analysis Shows Zero Jobs Recorded or Supported in the District</p>
      }
    </div>
  )
}

export { DistrictHeader, TopDistrictInstitutions };
